import React from 'react';
import { Link } from 'react-router-dom';

const CreateModal = ({ handleClose, show }) => {
  
  const showHideClassName = show ? 'modal show' : 'modal hide';

  return(
    <div className={showHideClassName}>
      <div className="content create">
        <button className="close" onClick={handleClose}>
          <i className="fa fa-angle-right"></i>
          <i className="fa fa-angle-left"></i>
        </button>
        <form>
          <h3 className="title">No projects for you!</h3>
          {/*<br />
          <h4 className="">Create your first board from your dashboard</h4>*/}
          <br />
          <p>
            <Link className="btn" to="/apps" >Create first project</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default CreateModal;


// WEBPACK FOOTER //
// ./src/components/CreateModal.js